import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import {
  ListItem as MuiListItem,
  ListItemIcon as MuiListItemIcon,
} from '@mui/material';

export const SIcon = styled(MuiListItemIcon)`
  margin: 5px auto;
  color: ${({theme}) => theme.palette.colors.white} !important;
  min-width: auto !important;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SNavLink = styled(NavLink)``;

export const SListItem = styled(MuiListItem)`
  ${({ theme }) => `
    border-radius: 20px !important;
    color: ${({theme}) => theme.palette.colors.white} !important;
    margin: 5px auto !important;
    height: 50px !important;
    width: 50px !important;
  
    &:hover {
      background-color: ${theme.palette.primary.dark} !important;
    }
  
    ${SNavLink}.selectedItem & {
      background-color: ${theme.palette.primary.dark} !important;
    }
  `}
`;
